import { render, staticRenderFns } from "./SubCategoryArchive.vue?vue&type=template&id=62ff6aec&"
import script from "./SubCategoryArchive.vue?vue&type=script&lang=js&"
export * from "./SubCategoryArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports